import { is } from 'typia'


export class StartPaymentSuccess {
  checkoutUrl: URL

  constructor(checkoutPath: string) {
    this.checkoutUrl = new URL(checkoutPath, window.location.origin)
  }
}


export class StartPaymentError {
  error: string

  constructor(error: string) {
    this.error = error
  }
}

const hasCheckoutUrl = (thing: unknown) => is<{ checkout_url: string }>(thing)
const hasError = (thing: unknown) => is<{ error: string }>(thing)
const isUnprocessableEntityFailureResponseDTO = (thing: unknown) => is<{ '@type': 'UnprocessableEntityFailureResponseDTO', detail: string }>(thing)

export const parseStartPaymentResponse = (responseBody: unknown): StartPaymentSuccess | StartPaymentError => {
  if (hasCheckoutUrl(responseBody)) {
    return new StartPaymentSuccess(responseBody.checkout_url)
  }
  if (hasError(responseBody)) {
    return new StartPaymentError(responseBody.error)
  }
  if (isUnprocessableEntityFailureResponseDTO(responseBody)) {
    return new StartPaymentError(responseBody.detail)
  }
  throw new Error(`Unknown response received from start payment: ${JSON.stringify(responseBody)}`)
}
